module.exports = __webpack_public_path__ + "img/9788961951562.ac82ce85.jpg";